import { TemporaryTokenManager } from '@cobliteam/api-lib/src/account/cobler/TemporaryTokenManager';
import { SessionManager } from '@cobliteam/api-lib/src/account/session/SessionManager';
import type { AccessibleFleet, Session } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { useMutation } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

/**
 * Troca a frota logada. Após sucesso, limpa o temporary token e recarrega a app no root — igual ao
 * antigo `changeUserFleetSaga`. O reload garante que todas as queries e stores hidratem no contexto
 * da nova frota.
 */
const useChangeFleet = () => {
  return useMutation<Session, unknown, AccessibleFleet>({
    mutationFn: (userFleet) => sessionManager.changeUserLoggedFleet(userFleet),
    onSuccess: () => {
      TemporaryTokenManager.deleteTemporaryToken();
      window.location.href = '/';
    },
    onError: () => Alert.error('Houve um erro ao tentar trocar de frota'),
  });
};

export default useChangeFleet;
